import { motion } from 'framer-motion'
import React from 'react'
import styled, { css } from 'styled-components'

type Variant = 'light' | 'dark' | 'black'

const borderColor = (variant: Variant) => {
  switch (variant) {
    case 'light':
      return 'var(--neutral-60)'
    default:
      return 'var(--neutral-20)'
  }
}

const spinnerColor = (variant: Variant) => {
  switch (variant) {
    case 'light':
      return 'white'

    default:
      return 'var(--neutral-80)'
  }
}

const Circle = styled(motion.div)<{ size: number; variant: Variant; $filled: boolean }>`
  ${({ size, variant }) => css`
    width: ${size}px;
    height: ${size}px;
    border: ${size / 5}px solid ${borderColor(variant)};
    border-top-color: ${spinnerColor(variant)};
  `}

  border-radius: 50%;
  position: relative;

  ${(props) =>
    props.$filled &&
    css`
      &::after {
        content: '';
        background-color: var(--neutral-80);
        height: 10px;
        width: 10px;
        border-radius: 50%;
        position: absolute;
        left: 2px;
        top: 2px;
      }
    `}
`

interface Props {
  className?: string
  size?: number
  variant?: Variant
  filled?: boolean
}
export const LoadingCircle = ({ className, size = 20, variant = 'light', filled = false }: Props) => (
  <Circle
    className={className}
    size={size}
    variant={variant}
    $filled={filled}
    animate={{ rotate: 360 }}
    transition={{
      repeat: Infinity,
      repeatType: 'loop',
      ease: 'linear',
      duration: 1
    }}
  />
)
